export const getPlanFeatures = (orgType = "operation") => {
  const isOperation = orgType === "operation";

  return {
    standard_free: isOperation
      ? [
          "Scheduling - 1 Daily (no recurring)",
          "Route Map Tracking",
          "Live Location Tracking - 5 employees",
          "Timesheets - Daily and Weekly",
          "Timesheets Approval",
          "Payroll - Weekly",
          "Members - 100",
          "Integrations",
          "Reporting",
        ]
      : [
          "Scheduling - 1 Daily (no recurring )",
          "Route Map Tracking",
          "Live Location Tracking - 5 employees",
          "Timesheets - Daily and Weekly",
          "Timesheets Approval",
          "Payroll - Weekly",
          "Members - 100",
          "Integrations",
          "Reporting",
        ],

    elite_free: isOperation
      ? [
          "Projects - unlimited",
          "Tasks - 1 daily",
          "Task Approval",
          "Photo, Audio Evidence Upload",
          "Task Notes - unlimited",
        ]
      : [
          "Customers - unlimited",
          "Jobs - 1 daily",
          "Job Approval",
          "Photo, Audio Evidence Upload",
          "Invoicing - unlimited",
          "Job Notes - unlimited",
        ],

    standard: isOperation
      ? [
          "Dashboard",
          "Team",
          "Scheduling",
          "Route Map Tracking",
          "Live Location Tracking",
          "Timesheets",
          "Timesheets Approval",
          "Payroll",
          "Members",
          "Integrations",
          "Reporting",
        ]
      : [
          "Dashboard",
          "Scheduling",
          "Route Map Tracking",
          "Live Location Tracking",
          "Timesheets",
          "Timesheets Approval",
          "Payroll",
          "Members",
          "Integrations",
          "Reporting",
        ],

    elite: isOperation
      ? [
          "Projects",
          "Tasks",
          "Task Approval",
          "Photo Evidence Upload",
          "Audio Evidence Recording",
          "Task Notes - Unlimited",
        ]
      : [
          "Customers",
          "Jobs",
          "Job Approval",
          "Photo Evidence Upload",
          "Audio Evidence Recording",
          "Job Notes - Unlimited",
        ],
  };
};

export const PlanPrice = {
  standard_free: 0,
  elite_free: 0,
  standard_mon: 15,
  standard_ann: 9,
  elite_mon: 20,
  elite_ann: 12,
};

// Plan features for SelectPlan (AddOrganization flow)
export const planFeatures = {
  solo: [
    "Team - 1",
    "Scheduling - 1 Daily",
    "Route Tracking",
    "Live Location Tracking - 3 employees",
    "Timesheets - Daily",
    "Payroll - Weekly",
    "Members - 10",
  ],
  standard: [
    "Scheduling - Unlimited",
    "Route Tracking - Unlimited",
    "Live Location Tracking - 10 employees",
    "Timesheets - Daily and Weekly",
    "Timesheets Approval",
    "Payroll - Weekly",
    "Members - 50",
    "Integrations",
  ],
  premium: [
    "Projects - Unlimited",
    "Tasks - Unlimited",
    "Task Approval",
    "Photo Evidence Upload",
    "Customers - Unlimited",
    "Mobile Field Services",
    "Offline Support",
  ],
  elite: [
    "Everything in Premium",
    "Remote Tracking",
    "Advanced Analytics",
    "Custom Integrations",
    "Priority Support",
    "Advanced Reporting",
  ],
};